import Maybe from "components/__new/common/Maybe";
import SearchBox from "components/__new/common/SearchBox";
import Table from "components/__new/common/Table";
import Pagination from "components/__new/common/pagination";
import useUrlNavigation from "hooks/useUrlNavigation";
import useUrlQueryParams from "hooks/useUrlQueryParams";
import { useState, useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { clearPayStructureITems, deleteMultiplePayStructures, deletePayStructure, getPayStructure, togglePayStructureGroupsModal } from "store/entities/payroll/payrollSetup/action";
import DateFormat from "utils/dateFormat";
import IconEmptyBox from "assets/images/icons/project-icons/empty-box.png";
import processParams from "utils/processParams";
import DropdownNew from "utils/dropdown";
import usePayrollEssentials from "hooks/usePayrollEssentials";
import { TableContent } from "components/__new/common/TableContent";
import DialogBox from "utils/dialogBox";
import PayStructureGroupsAssignmentModal from "components/__new/grossPayroll/structure/PayStructureGroupsAssignmentModal";
import useLoginInfo from "hooks/useLoginInfo";
import logger from "utils/logger";
import DeletePayStructure from "../../../components/__new/payroll/DeletePayStructure";
import DynamicHeadTag from "components/__new/common/DynamicHeadTag";
import Filter, { ActiveFilter } from "components/__new/common/Filter";
import PayStructureForm from "components/__new/payroll/PayStructureForm";
import ViewPayStructureDetails from "../../../components/__new/payroll/ViewPayStructureDetails";
import useMultiSelect from "hooks/useMultiSelect";
import { ReactComponent as IconTrash } from "assets/images/icons/project-icons/thrash.svg";
import { ReactComponent as IconsTimes } from "assets/images/icons/project-icons/times.svg";


const PayStructure = () => {
    const location = useLocation();
    const {urlQuery} = useUrlNavigation();
    const {useSelector, dispatch, history} = usePayrollEssentials();
    const {userInfo} = useLoginInfo();
    const { selections, toggleMultiSelectHeader, getMultiSelectBody, clearSelections } = useMultiSelect();

    const {urlQueryParams} = useUrlQueryParams();
    const [listParams, setListParams] = useState({ "page": 1, "limit": 10 });
    const [payStructure, setPayStructure] = useState({})
    const [payStructureGroups, setPayStructureGroups] = useState([]);
    const [isOpenPayStructureForm, setIsOpenPayStructureForm] = useState(false);
    const [isOpenDeletePayStructure, setIsOpenDeletePayStructure] = useState(false);
    const [isOpenPayStructureDetails, setIsOpenPayStructureDetails] = useState();
    const [sortOptions, setSortOptions] = useState([
        {
            title: <>Date Created <FontAwesomeIcon icon="arrow-up" className="ml-2 mt-0.5" /></>,
            link: urlQuery("sort=createdAt&order=asc"),
            data: {sort: 'createdAt', order: 'asc'},
            active: false,
        },
        {
            title: <>Date Created <FontAwesomeIcon icon="arrow-down" className="ml-2 mt-0.5" /></>,
            link: urlQuery("sort=createdAt&order=desc"),
            data: {sort: 'createdAt', order: 'desc'},
            active: false,
        },
    ]);
                                                
    const GroupColorsMap = {
        0: {
            bg: "#F9F5FF",
            color: "#6941C6"
        },
        1: {
            bg: "#EFF8FF",
            color: "#175CD3"
        },
        2: {
            bg: "ep-grey",
            color: "ep-blue"
        },
    }

    const {getPayStructureData: payStructureData, getPayStructureLoading: loading, deletePayStructureLoading, deleteMultipleStructuresLoading: multipleDeleteLoading, deletePayStructureResponse, getPayGroupData: payGroupData} = useSelector(state => state.entities.payrollSetup)

    // const structureValid = !loading && payStructureData?.data?.length > 0
    const structureValid = !loading && payStructureData?.data?.length > 0
    // const createStructure =  () => {
    //     logger("Employer-Payroll-setup-paystructure-create-attempt", userInfo);
    //     history.push("/payroll-configuration/pay-structure/create");
    // }
    const paginationData = useMemo(() => {
        if (!payStructureData?.data) return {};
        
        const { data, ...paginationInfo } = payStructureData;
        return paginationInfo;
    }, [payStructureData])
    
    const createStructure = () => {
        logger("Employer-Payroll-setup-paystructure-create-attempt", userInfo);
        setPayStructure({});
        setIsOpenPayStructureForm(true);
    }
    
    const updatePayStructure = (data) => {
        setPayStructure(data);
        setIsOpenPayStructureForm(true);
    }
    
    // const allStructureIDs = payStructureData?.data?.map(item => item.id)
    // const allStructureIDs = payStructureData?.data?.map((item, index) => index+1)

    const getPayStructures = () => {
        let params = {...listParams};
        params = processParams(urlQueryParams, params, "page", "number", 1, "page");
        params = processParams(urlQueryParams, params, "limit", "number", 10, "limit");
        params = processParams(urlQueryParams, params, "status", "string", "", "status");
        params = processParams(urlQueryParams, params, "search", "string", "", "search");
        params = processParams(urlQueryParams, params, "sort", "string", "", "sortBy");
        params = processParams(urlQueryParams, params, "order", "string", "", "sortOrder");
      
        params = processParams(urlQueryParams, params, "startDate", "string", "", "startDate");
        params = processParams(urlQueryParams, params, "endDate", "string", "", "endDate");
        params = processParams(urlQueryParams, params, "dateRange", "string", "", "dateRange"); 

        const sortValue = urlQueryParams["sort"];
        const orderValue = urlQueryParams["order"];
        if (sortValue && orderValue) {
            const newSortOptions = sortOptions?.map((sortOption) => {
                if (sortOption?.data?.sort === sortValue && sortOption?.data?.order === orderValue) {
                    return {...sortOption, active: true};
                }
                else {
                    return {...sortOption, active: false};
                }
            })
            setSortOptions(newSortOptions);
        }
        setListParams(params);
        dispatch(getPayStructure(params));
    }

    // const toggleSingleItem = (id) => {
    //     const alreadyExists = batch?.indexOf(id) > -1
    //     if (alreadyExists) {
    //         const filtered = batch?.filter(item => item !== id)
    //         setBatch(filtered)
    //     } else {
    //         setBatch([...batch, id])
    //     }
    // }

    // const toggleEntireList = () => {
    //     if (batch.length !== allStructureIDs?.length) {
    //         setBatch(allStructureIDs)
    //     } else {
    //         setBatch([])
    //     }
    // }

    const deleteStructure = async () => {
        dispatch(deletePayStructure(payStructure.id));
        // setIsOpenDeletePayStructure(false);
        // toast.success('Pay structure successfully deleted');
        // const result = await DialogBox({
		// 	title: "Delete Pay Structure 😰",
        //     content: <div className="delete-modal-text">Are you sure you want to delete <span className="delete-modal-highlight">{truncator(item.name)}</span>? This action cannot be undone.</div>,
		// 	buttonYes: "Delete",
        //     buttonYesClass: "btn-ep-red",
		// 	buttonNo: "Cancel",
		// });
		// if (result) {
        //     dispatch(deletePayStructure(item.id));
        // }
    }

    const handleBulkDelete = async () => {
        const result = await DialogBox({
			title: "Delete Pay Structures 😰",
			content: <div className="delete-modal-text">Are you sure you want to delete <span className="delete-modal-highlight">{selections?.length} pay structures</span>? This action cannot be undone.</div>,
			buttonYes: "Delete",
            buttonYesClass: "btn-ep-red",
			buttonNo: "Cancel",
		});
        
        if (result) {
            const selectedIds = selections.map((selection) => JSON.parse(selection).id);
            // console.log("selectedIds", selectedIds);
            // dispatch(payrollSetupAction.deleteMultiplePaySchedules({ids: selectedIds}));
            dispatch(deleteMultiplePayStructures({ids: selectedIds}));
        }
    }

    const handleToggleEditForm = () => {
        setIsOpenPayStructureForm(!isOpenPayStructureForm);
    }
    
    useEffect(() => {
        getPayStructures()
        // eslint-disable-next-line
    }, [location])

    useEffect(() => {
        dispatch(clearPayStructureITems());
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        if(deletePayStructureResponse?.id !== undefined || deletePayStructureResponse?.count !== undefined) {
            history.push({ ...urlQueryParams, page: 1 });
            // getPayStructures();
            setIsOpenDeletePayStructure(false);
            clearSelections();
        }
        // eslint-disable-next-line
    }, [deletePayStructureResponse])

    return (
        <div>
            
            <PayStructureGroupsAssignmentModal payStructureId={payStructure?.id} />

            {/* <PayStructureGroupsAssignmentModal /> */}
            
            <DynamicHeadTag
                headerText="Pay Structure"
                // headerDescription="Optimize your payment management by configuring specific dates and intervals for employee salaries and wages with our flexible pay schedule feature"
            />
            
            <PayStructureForm
                isOpen={isOpenPayStructureForm}
                setIsOpen={setIsOpenPayStructureForm}
                payStructure={payStructure}
                getPayStructures={getPayStructures}
            />
            
            <ViewPayStructureDetails
                isOpen={isOpenPayStructureDetails}
                setIsOpen={setIsOpenPayStructureDetails}
                payStructure={payStructure}
                payStructureGroups={payStructureGroups}
                GroupColorsMap={GroupColorsMap}
                handleToggleEditForm={handleToggleEditForm}
            />
            
            <DeletePayStructure
                loading={deletePayStructureLoading}
                isOpen={isOpenDeletePayStructure}
                setIsOpen={setIsOpenDeletePayStructure}
                onProceed={deleteStructure}
            />

            {/* {loading === true && <Spinner message="Fetching Pay Structures" />} */}

            {/* {urlQueryParams?.search === undefined && loading === false && payStructureData?.data && payStructureData?.data?.length === 0 &&
                <EmptyDataUI
                    subheader={<span>Let's create a custom structure that fits your organization. You can <br /> create as many structures as needed</span>}
                    onBtnClick={createStructure}
                    btnText="+ Create New Payroll Structure" />
            } */}

                <>

                    <div className="box !px-0 !pb-0">
                        <div className="px-6 font-medium text-xl">
                            Pay Structure
                        </div>

                        <div className={`px-6 mt-6 xl:flex flex-wrap ${selections?.length > 1 ? "justify-start" : "justify-between"}`}>
                            <div className="flex-grow flex items-center">
                                {/* <div className="flex">
                                    <input type="checkbox" className="form-checkbox w-5 h-5 multi-select-header" onChange={toggleEntireList}
                                        checked={allStructureIDs?.length > 0 && batch.length === allStructureIDs?.length}
                                    />
                                </div>
                                <div className="w-10 flex justify-center items-center">
                                    <IconDotH className="h-6 svg-fill-ccc" />
                                </div>
                                <Maybe condition={batch?.length > 1}>
                                    <div className="flex items-center">
                                        <BulkActionHandler
                                            loading={multipleDeleteLoading}
                                            count={batch?.length}
                                            onCancel={() => setBatch([])}
                                            onDelete={handleBulkDelete}
                                        />
                                    </div>
                                </Maybe>
                                <Maybe condition={batch?.length < 2}>
                                    <div className="w-full max-w-sm sm:mr-6">
                                        <SearchBox placeholder="Search for pay structure" name="search" extraUrlParams="page=1" />
                                    </div>
                                </Maybe> */}
                                <div className="flex mr-4">
                                    <input type="checkbox" className="form-checkbox w-5 h-5 multi-select-header" onChange={toggleMultiSelectHeader} />
                                </div>
                                {/* <div className="w-10 flex justify-center items-center">
                                    <IconDotH className="h-6 svg-fill-ccc" />
                                </div> */}
                                <Maybe condition={selections?.length > 0}>
                                    <div className="flex flex-wrap items-center">
                                        <button type="button" onClick={handleBulkDelete} className="dropdown-item dropdown-item-icon text-red-500" disabled={multipleDeleteLoading}>
                                            <Maybe condition={multipleDeleteLoading === true}>
                                                <FontAwesomeIcon icon="circle-notch" spin className="text-xl" style={{margin: "auto 0.5rem auto 0"}} />
                                            </Maybe>
                                            <Maybe condition={multipleDeleteLoading === false}>
                                                <IconTrash style={{height: "1.25rem", marginRight: "0.5rem"}} />
                                            </Maybe>
                                            Delete
                                        </button>

                                        <div className="mx-2 sm:mx-6">
                                            <div className="w-0.5 h-4 bg-gray-200"></div>
                                        </div>

                                        <div className="flex space-x-4">
                                            <div className="text-[#6C757D]">
                                                {selections?.length} selected
                                            </div>
                                            <button type="button" onClick={clearSelections}>
                                                <IconsTimes className="svg-fill-red" />
                                            </button>
                                        </div>
                                    </div>
                                </Maybe>
                                <Maybe condition={selections?.length === 0}>
                                    <div className="w-full max-w-sm sm:mr-6">
                                        <SearchBox placeholder="Search Pay Structure" name="search" extraUrlParams="page=1" />
                                        </div>
                                </Maybe>
                            </div>
                            <Maybe condition={selections?.length === 0}>
                                <div className="mt-2 xl:mt-0 flex flex-wrap space-x-3 sm:space-x-6">

                                        {/* <div>
                                            <Filter filters={[
                                                {
                                                title: "Status",
                                                name: "status",
                                                dataType: "select",
                                                options: [
                                                    {
                                                        display: "All",
                                                        payload: "",
                                                    },
                                                    {
                                                        display: "Assigned",
                                                        payload: "assigned",
                                                    },
                                                    {
                                                        display: "Unassigned",
                                                        payload: "unassigned",
                                                    },
                                                ],
                                            },
                                            ]}/>
                                        </div> */}
                                    {/* <div>
                                        <SortBy options={sortOptions} title="Sort Order: " firstOption='Select' />
                                    </div> */}
                                    <div>
                                        <Filter 
                                            filters={[
                                                {
                                                    title: "Date range",
                                                    name: "dateRange",
                                                    dataType: "custom-timeframe",
                                                    hasResetButton: true,
                                                    options: [
                                                        {
                                                            display: "Today",
                                                            payload: "today",
                                                        },
                                                        {
                                                            display: "Last 7 days",
                                                            payload: "last_7_days",
                                                        },
                                                        {
                                                            display: "30 days",
                                                            payload: "30_days",
                                                        },
                                                        {
                                                            display: "1 Year",
                                                            payload: "1_year",
                                                        },
                                                    ],
                                                },
                                                {
                                                    title: "Custom date range",
                                                    dataType: "date-range",
                                                    options: {
                                                        from: {
                                                            name: "startDate",
                                                            placeholder: "Start Date",
                                                        },
                                                        to: {
                                                            name: "endDate",
                                                            placeholder: "End Date",
                                                        },
                                                    },
                                                },
                                            ]}
                                        />
                                    </div>
                                    <div className="payroll-setup-main-page-action">
                                        <button disabled={loading || multipleDeleteLoading} onClick={createStructure} className="btn btn-md btn-ep-primary">
                                            <FontAwesomeIcon icon="plus" className="mr-2" />
                                            Create New Structure
                                        </button>
                                    </div>

                                </div>
                            </Maybe>
                        </div>
                        
                        <div className="px-6">
                            <ActiveFilter 
                                filters={{
                                    "Date range": "dateRange",
                                    "Period start date": "startDate", 
                                    "Period end date": "endDate",
                                }} 
                            />
                        </div>

                        <div className="mt-6">
                            <div>
                                <div className="mb-4 text-xl hidden print:block">
                                    Pay Structure
                                </div>

                                <Table>
                                    <Table.Head>
                                        <th style={{ paddingRight: 0, paddingLeft: "1.5rem" }}></th>
                                        <th style={{ paddingLeft: 0 }}>Structure Name</th>
                                        <th>No. of Employees</th>
                                        <th>Date Created</th>
                                        <th>Assigned to Group</th>
                                        {/* <th>Status</th> */}
                                        <th></th>
                                    </Table.Head>
                                    <Table.Body>

                                        <TableContent
                                            loading={loading || multipleDeleteLoading}
                                            empty
                                            loadingText={`${multipleDeleteLoading ? "Deleting Multiple Pay Structures" : "Fetching Pay Structures"}`}
                                            data={payStructureData?.data}
                                            total={payStructureData?.data?.length}
                                            colspan={6}
                                            emptyUI={<>
                                                <div className="py-20 mx-auto text-center text-base">
                                                    <div className="flex justify-center">
                                                        <img src={IconEmptyBox} alt="Empty" className="h-48" />
                                                    </div>
                                                    <div className="text-[#101828] font-medium">
                                                        No Data Available
                                                    </div>
                                                    <div onClick={createStructure} className="mt-1 underline cursor-pointer text-[#4A5564]">
                                                        Click here to create pay structure
                                                    </div>
                                                </div>
                                            </>}
                                        />

                                        {(!loading && !multipleDeleteLoading) && payStructureData?.data?.map((structure, index) => {
                                            const assignedGroups = payGroupData?.data?.filter(payGroup => payGroup?.pay_structure_id === structure?.id);
                                            let employeeCount = 0;
                                            
                                            payGroupData?.data?.filter(payGroup => payGroup?.pay_structure_id === structure?.id).flat().forEach((payGroup) => {
                                                employeeCount += payGroup?.employees?.length;
                                            });
                                            
                                            return (
                                                <tr key={index}>
                                                    <td style={{ paddingRight: "15px", paddingLeft: "1.5rem", width: "20px" }}>
                                                        {/* <input
                                                            type="checkbox"
                                                            className="form-checkbox w-5 h-5 multi-select"
                                                            onChange={() => toggleSingleItem(index)}
                                                            checked={batch?.includes(index)}
                                                            value={index}
                                                        /> */}
                                                        <input
                                                            type="checkbox"
                                                            className="form-checkbox w-5 h-5 multi-select"
                                                            onChange={getMultiSelectBody}
                                                            checked={selections?.filter((selection) => JSON.parse(selection).id === structure.id).length === 1}
                                                            value={JSON.stringify(structure)}
                                                        />
                                                    </td>
                                                    <td className="td-word-break" style={{ paddingLeft: 0, width: "350px" }}>
                                                        <div className="capitalize">
                                                            {structure?.name?.toLowerCase()}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="lt-gray">
                                                            {employeeCount}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="lt-gray">
                                                            {DateFormat(structure?.createdAt)}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="lt-gray capitalize">
                                                            {/* {structure?.assignedGroup === 'sales' && <span className="bg-[#F9F5FF] text-[#6941C6] rounded-full py-1 px-4">sales</span>}
                                                            {structure?.assignedGroup === 'engineering' && <span className="bg-[#EFF8FF] text-[#175CD3] rounded-full py-1 px-4">engineering</span>}
                                                            {structure?.assignedGroup === '' && <span className="bg-[#F2F4F7] text-[#344054] rounded-full px-4 py-1">not assigned</span>} */}
                                                            {
                                                                structure?.status === "assigned" ? (
                                                                    <div className="flex flex-wrap gap-2">
                                                                        {assignedGroups?.length > 0 ? assignedGroups?.slice(0, 3)?.map((assignedGroup, index) => {
                                                                            
                                                                            return (
                                                                                <span className={`bg-[${GroupColorsMap[index]?.bg}] text-[${GroupColorsMap[index]?.color}] rounded-full py-1 px-4`} key={index}>
                                                                                    {assignedGroup?.name || ""}
                                                                                </span>  
                                                                            )
                                                                        }) : (
                                                                            <span className="bg-[#F2F4F7] text-[#344054] rounded-full px-4 py-1">Not Assigned</span>
                                                                            )
                                                                        }
                                                                        {
                                                                            assignedGroups?.length > 3 && (
                                                                                <span className="bg-[#F2F4F7] text-[#344054] rounded-full px-4 py-1">
                                                                                    + {assignedGroups?.length - 3}
                                                                                </span>
                                                                            )
                                                                        }
                                                                    </div>
                                                                ) : structure?.status === "unassigned" && (
                                                                    <span className="bg-[#F2F4F7] text-[#344054] rounded-full px-4 py-1">
                                                                        not assigned
                                                                    </span>
                                                                )
                                                            }
                                                        </div>
                                                    </td>
                                                    {/* <td>
                                                        <AssignmentLabel isAssigned={structure?.status === 'assigned'} />
                                                    </td> */}
                                                    <td>
                                                        <>
                                                        
                                                        <DropdownNew iconClassName="rotate-90">
                                                            <></>
                                                            <div>
                                                                <div 
                                                                    onClick={() => {
                                                                        setPayStructure(structure);
                                                                        setPayStructureGroups(assignedGroups);
                                                                        setIsOpenPayStructureDetails(true);
                                                                    }} 
                                                                    className="dropdown-item"
                                                                >
                                                                    View
                                                                </div>
                                                                <div 
                                                                    onClick={() =>      updatePayStructure(structure)} className="dropdown-item"
                                                                >
                                                                    Edit
                                                                </div>
                                                                <div 
                                                                    onClick={() => {
                                                                        setPayStructure(structure);
                                                                        dispatch(togglePayStructureGroupsModal())    
                                                                    }} 
                                                                    className="dropdown-item"
                                                                >
                                                                    Assign to group
                                                                </div>
                                                                <div 
                                                                    onClick={() => {
                                                                        setPayStructure(structure)
                                                                        setIsOpenDeletePayStructure(true)
                                                                    }} 
                                                                    className="dropdown-item text-red-500"
                                                                >
                                                                    Delete
                                                                </div>
                                                            </div>
                                                        </DropdownNew>
                                                        </>
                                                    </td>
                                                </tr>
                                            )}
                                        )}

                                    </Table.Body>
                                </Table>
                                <Maybe condition={structureValid}>
                                    <div className="mt-6">
                                        <Pagination data={paginationData} limit={paginationData?.limit} />
                                    </div>
                                </Maybe>
                            </div>
                        </div>
                    </div>
                </>
        </div>
    )
}


export default PayStructure;